import {KpiRangeBreachSeverity} from '@hconnect/common/types'
import {formatNumber} from '@hconnect/common/utils'
import {Stack, Typography} from '@mui/material'
import React from 'react'

import {KpiThresholdIcon} from './KpiThresholdIcon'

type Props = {
  value: string
  language?: string
  unit?: string
  showKpiStatusIndicator?: boolean
  kpiBreachSeverity: KpiRangeBreachSeverity | null
  dataTestId?: string
}
export const KpiValue: React.FC<Props> = ({
  value,
  language,
  unit,
  showKpiStatusIndicator,
  kpiBreachSeverity,
  dataTestId
}) => {
  const numericValue = parseFloat(value)

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end" alignItems="center">
      <Typography variant="body1">
        {!isNaN(numericValue)
          ? `${formatNumber(numericValue, language ?? '')}${unit ? ` ${unit}` : ''}`
          : value || '-'}
      </Typography>
      {showKpiStatusIndicator && !!kpiBreachSeverity && (
        <KpiThresholdIcon status={kpiBreachSeverity} dataTestId={dataTestId} />
      )}
    </Stack>
  )
}
